// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"ProjectSelectedModal_modalTitle_3_iyg","chevron":"ProjectSelectedModal_chevron_3bpnk","spinAround":"ProjectSelectedModal_spinAround_1hvUy"};